const STORAGE_KEY = "sidebarCollapsed";

export function initHamburgerToggle(): () => void {
  const app = document.querySelector<HTMLElement>(".app-container");
  const toggles = Array.from(document.querySelectorAll<HTMLButtonElement>("#sidebar_toggle, .hamburger-btn"));
  if (!app || toggles.length === 0) return () => {};

  const mask = document.getElementById("sidebar_mask");

  const apply = (collapsed: boolean) => {
    app.classList.toggle("collapsed", collapsed);
    toggles.forEach(btn => btn.setAttribute("aria-expanded", collapsed ? "false" : "true"));
  };

  const stored = (() => {
    try { return localStorage.getItem(STORAGE_KEY); } catch { return null; }
  })();
  apply(stored === "1");

  const setCollapsed = (collapsed: boolean) => {
    apply(collapsed);
    try { localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0"); } catch {}
  };

  const onToggle = (e: Event) => {
    e.preventDefault();
    const next = !app.classList.contains("collapsed");
    setCollapsed(next);
  };

  const onMaskClick = (e: Event) => {
    e.preventDefault();
    setCollapsed(true);
  };

  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Escape" && !app.classList.contains("collapsed")) {
      setCollapsed(true);
    }
  };

  toggles.forEach(btn => {
    btn.addEventListener("click", onToggle);
    btn.setAttribute("aria-expanded", app.classList.contains("collapsed") ? "false" : "true");
  });
  mask?.addEventListener("click", onMaskClick);
  document.addEventListener("keydown", onKeyDown);

  return () => {
    toggles.forEach(btn => btn.removeEventListener("click", onToggle));
    mask?.removeEventListener("click", onMaskClick);
    document.removeEventListener("keydown", onKeyDown);
  };
}

export function initUserDropdownToggle(): () => void {
  const dropdown = document.querySelector<HTMLDivElement>(".topbar .dropdown");
  const trigger = dropdown?.querySelector<HTMLElement>("#userDropdown");
  const menu = dropdown?.querySelector<HTMLElement>("#dropdownMenu");
  if (!dropdown || !trigger || !menu) return () => {};

  let open = menu.classList.contains("show");

  const apply = (next: boolean) => {
    open = next;
    dropdown.classList.toggle("show", open);
    trigger.classList.toggle("show", open);
    menu.classList.toggle("show", open);
    trigger.setAttribute("aria-expanded", open ? "true" : "false");
  };

  const onTriggerClick = (e: Event) => {
    e.preventDefault();
    apply(!open);
  };
  const onDocClick = (e: MouseEvent) => {
    if (!open) return;
    const target = e.target as Node | null;
    if (trigger.contains(target) || menu.contains(target)) return;
    apply(false);
  };
  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Escape" && open) {
      apply(false);
      trigger.focus();
    }
  };

  trigger.addEventListener("click", onTriggerClick);
  document.addEventListener("click", onDocClick);
  document.addEventListener("keydown", onKeyDown);

  return () => {
    trigger.removeEventListener("click", onTriggerClick);
    document.removeEventListener("click", onDocClick);
    document.removeEventListener("keydown", onKeyDown);
  };
}